import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'
import {useParams} from 'react-router'

const ContentExports = lazy(() =>
  import('./components/pages/ContentExports').then(({ContentExports}) => ({
    default: ContentExports,
  })),
)

export function ContentExportsPage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Exports for this Quiz'))

  return (
    <Suspense>
      <ContentExports activeAssignmentId={activeAssignmentId} />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the exports module.
 */
export const exportsRoutes = [
  {
    index: true,
    element: <ContentExportsPage />,
  },
]
